// extracted by mini-css-extract-plugin
export default {"recos":"r2-z","productCardOverride":"s2-z","rowHasBadge":"t2-z"};